import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import { usePathname } from "next/navigation";
import { signOut, useSession } from "next-auth/react";

export default function useAuth(shouldRedirect = true) {
  const session = useSession();
  const router = useRouter();
  const pathname = usePathname();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const publicRoutes = [
    "/login",
    "/home",
    "/city-landing",
    "/activity",
    "/",
    "/about-us",
    "/sobre-nosotros",
    "/proveedores",
    "/providers",
    "/blog",
    "/faqs",
    "/contacto",
    "/contact",
    "/terms-and-conditions",
    "/aviso-legal",
    "/confirmation",
  ];

  useEffect(() => {
    const currentPathWihoutLng =
      pathname.split("/")[2] === undefined ? "/" : "/" + pathname.split("/")[2];
    //@ts-ignore
    if (session.data?.error === "RefreshAccessTokenError") {
      signOut({ callbackUrl: "/login", redirect: shouldRedirect });
    }
    if (session.data === null) {
      //removing lng from pathname
      if (!publicRoutes.includes(currentPathWihoutLng)) {
        router.replace("/login");
        setIsAuthenticated(false);
      }
    } else if (session.data !== undefined) {
      if (currentPathWihoutLng === "/login") {
        router.replace("/home");
      }
      setIsAuthenticated(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router, session, pathname, shouldRedirect]);
  return { isAuthenticated, session };
}
